.delay-input-wrapper {
    margin-top: 8px;
}

.delay-text {
    color: var(--grey-lt);
    margin: 8px 0;
}
